import { createContext, useContext } from "react";
export var AuthContext = createContext(void 0);
export var useAuth = function useAuth() {
  return useContext(AuthContext);
};